// eslint-disable-next-line no-shadow
enum CommunicationType {
  WHATSAPP,
  EMAIL,
  PUSH_NOTIFICATION,
}
export default CommunicationType;
